<template>
  <div class="py-3">
    <div v-if="title" class="mb-2 flex items-baseline">
      <p
        :class="
          cn('ui-text-xs font-medium mr-1.5 uppercase text-white', labelClass)
        "
      >
        {{ title }}
      </p>
    </div>
    <div class="flex flex-wrap gap-1">
      <button
        v-for="item in block.materials as MaterialData[]"
        :key="item.id"
        class="group relative p-0.5 border overflow-hidden rounded-full"
        :class="{
          'border-primary': selectedItem?.id === item.id,
        }"
        :disabled="item.disabled"
        :aria-label="item.currentTranslation?.title"
        @click="onFilterClick(block.slug, item)"
      >
        <UiLazyImg
          class="size-3.5 overflow-hidden rounded-full object-contain group-disabled:opacity-50"
          :class="[
            block.slug === propertiesGroupSlugs.diamondShape
              ? 'transition-all md:group-hover:scale-[1.1]'
              : '',
          ]"
          :src="
            getImageByPosition(item.medias, 'list')?.file?.url ||
            '/images/no-image.webp'
          "
          :alt="
            getImageByPosition(item.medias, 'list')?.file?.alt ||
            getFilterImageAlt(item, block)
          "
        />
      </button>
    </div>
    <SharedFieldHint :message="errorMessage" error />
    <slot name="additional" />
  </div>
</template>

<script setup lang="ts">
import { useField } from "vee-validate";
import { IProductMaterialFilterProps, MaterialData } from "ecom-types";
import { propertiesGroupSlugs } from "~/configs";

const props = defineProps<IProductMaterialFilterProps>();

const emit = defineEmits<{
  (e: "filter", value: { slug: string; item: MaterialData }): void;
}>();

function getFilterImageAlt(option: MaterialData, category: any) {
  return joinBySelector(
    [category?.currentTranslation?.title, option?.currentTranslation?.title],
    " ",
  );
}

const { errorMessage, setValue } = useField(props.block?.slug, undefined, {
  initialValue: props.selectedItem?.sku,
});

function onFilterClick(slug: string, item: MaterialData) {
  setValue(item.sku);
  emit("filter", { slug, item });
}

</script>
